import type { RefObject } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";

// Whether the element's text is cut off by its clamp; measured only while it is clamped, and again when it resizes.
export function useClipped<T extends HTMLElement>(clamped: boolean, content: string): [RefObject<T>, boolean] {
	const ref = useRef<T>(null);
	const [clipped, setClipped] = useState(false);
	useEffect(() => {
		const element = ref.current;
		if (!element || !clamped || typeof ResizeObserver === "undefined") return undefined;
		const measure = () => setClipped(element.scrollHeight > element.clientHeight + 1);
		measure();
		const observer = new ResizeObserver(measure);
		observer.observe(element);
		return () => observer.disconnect();
	}, [clamped, content]);
	return [ref, clipped];
}
